
<div class="delete-dialog-container">
  <div class="delete-dialog-header">
    <mat-icon class="warning-icon">warning</mat-icon>
    <h2>Supprimer la publication ?</h2>
  </div>

  <div class="delete-dialog-body">
    <p>Cette action est <span class="highlight">irréversible</span>. La publication et tous ses commentaires seront définitivement supprimés.</p>
  </div>

  <div class="delete-dialog-actions">
    <button mat-button class="cancel-button" (click)="onCancel()">
      <mat-icon>close</mat-icon>
      Annuler
    </button>
    <button mat-raised-button class="delete-button" (click)="onConfirm()">
      <mat-icon>delete_forever</mat-icon>
      Supprimer
    </button>
  </div>
</div>
